module.exports = __webpack_public_path__ + "img/__icon_BUS_EKSPRES.ea59c68a.svg";